/**
 * Takes a HTML string and coverts it into an HTMLElement.
 *
 * @example
 * const div = stringToHTML('<div></div>');
 * div.style.border = '1px solid red';
 *
 * // this is the same as this in jQuery $('<div />')[0]
 *
 * @param {string} htmlString The string to convert into an HTMLElement object
 */
export default function stringToHTML(htmlString) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(htmlString, "text/html");
    return doc.body.firstChild;
}
